import React, {useState, useEffect} from "react";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import Dropdown from "../../Component/Dropdown/Drowdown";
import toast from "react-hot-toast";


export default function MyProfile() {


    const [profile, setProfile] = useState({
        address: "",
        country: {
            _id: "",
            name: ""
        },
        email: "",
        mobile: "",
        userName: "",
        password: ""
    });

    const [showModalCategory, setShowModalCategory] = useState(false);
    const [countryListData, setCountryListData] = useState([])
    const [loadingCountry, setLoadingCountry] = useState(false);

    const [loadingForBtn, setLoadingForBtn] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        apiRequests.get("/api/seller/v1/get-my-profile")
            .then((response) => {
                const data = response.data.data
                setProfile({
                    address: data.address,
                    country: {
                        _id: data.country._id,
                        name: data.country.name
                    },
                    email: data.email,
                    mobile: data.mobile,
                    userName: data.userName,
                    password: ""
                });
            })
            .catch(() => {
            })
            .finally(() => setLoading(false));


    }, [])

    useEffect(() => {

        setLoadingCountry(true)
        apiRequests.get("/api/country/get-all?limit=20&page=1")
            .then((res) => {
                setCountryListData(res.data.data.docs)
            })
            .catch()
            .finally(() => {
                setLoadingCountry(false)
            });

    }, []);

    const handleCountryChange = (selectedCountry) => {
        setProfile((prevUser) => ({
            ...prevUser,
            country: selectedCountry,
        }));
        setShowModalCategory(false);
    };

    function UpdateProfile() {

        const data = {

            userName: profile.userName,
            email: profile.email,
            address: profile.address,
            country: profile.country.id,
            password: profile.password,
            mobile: profile.mobile

        }

        setLoadingForBtn(true)
        apiRequests.patch(`/api/seller/v1/edit-seller-profile`, data)
            .then((response) => {
                toast.success("successfully updated product!")
                window.location.reload()
            })
            .catch(() => {
            })
            .finally(() => setLoadingForBtn(false));

    }

    return (


        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                My Profile
            </div>


            <div className="grid grid-cols-2 auto-cols-auto md:flex md:flex-col gap-3 mt-3">

                {loading ?

                    <Loading/>
                    :
                    <>

                        <div className="flex flex-col gap-2 text-xl">
                            user name
                            <input value={profile.userName || "-"}
                                   onChange={(e) => setProfile({...profile, userName: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                        <div className="flex flex-col gap-2 text-xl">
                            Mobile
                            <input value={profile.mobile || "-"}
                                   onChange={(e) => setProfile({...profile, mobile: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                        <div className="flex flex-col gap-2 text-xl">

                            Country
                            <div className="inline-block relative w-full"
                                 onClick={() => setShowModalCategory(!showModalCategory)}>
                                <input className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"
                                       value={profile.country.name}
                                       readOnly
                                       placeholder="click for change Country"/>

                                {showModalCategory && <Dropdown data={countryListData} setOpen={setShowModalCategory}
                                                                setValue={handleCountryChange}/>
                                }

                            </div>
                        </div>

                        <div className="flex flex-col gap-2 text-xl">
                            Address
                            <input value={profile.address || "-"}
                                   onChange={(e) => setProfile({...profile, address: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>


                        <div className="flex flex-col gap-2 text-xl">
                            Email
                            <input value={profile.email || "-"}
                                   onChange={(e) => setProfile({...profile, email: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>


                        <div className="flex flex-col gap-2 text-xl">
                            New Password
                            <input value={profile.password}
                                   onChange={(e) => setProfile({...profile, password: e.target.value})}
                                   className="min-h-10 border-2 border-marginColor-shade4 w-2/3 p-2 rounded-md"/>
                        </div>

                    </>
                }


            </div>


            {!loading &&
                <button
                    className="mt-6 text-lg text-white hover:bg-white hover:text-baseColor-first py-2 px-4 rounded-md border-2 border-buttonColor-shade5 bg-buttonColor-shade5"
                    onClick={UpdateProfile}
                >
                    {!loadingForBtn ?
                        "Update My Profile"
                        :
                        "loading ..."
                    }

                </button>

            }

        </div>
    )
}